import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const skipErrorToast = () => new HttpContext().set(SKIP_ERROR_TOAST, true);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  return next(req).pipe(
    catchError(error => {
      if (!req.context.get(SKIP_ERROR_TOAST)) {
        const message = error?.error?.error ?? 'An unexpected error occurred';
        toastr.error(message, 'Error');
      }
      return throwError(() => error);
    })
  );
};
